import { useState } from "react";
import { FaFacebookF, FaTiktok , FaInstagram, FaYoutube, FaLink } from "react-icons/fa";

export default function ShareButtons() {
  const [isModalOpen, setModalOpen] = useState(false);
  const shareUrl = "https://www.gloriousevidence.com/blog"; 

  
  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    alert("Link copied to clipboard!");
  };

  return (
    <div className="z-50">
      {/* Share Button */}
      <button 
        onClick={() => setModalOpen(true)}
        className="w-8 h-8 flex items-center justify-center bg-red-500 text-white rounded-full hover:bg-red-600"
      >
        <FaLink size={16} />
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-[22rem] text-center">
            <h2 className="text-xl font-bold mb-4">Share This Link</h2>
            
            <input 
              type="text" 
              value={shareUrl} 
              readOnly 
              className="w-full p-2 border border-gray-300 rounded-md"
            />

            <button 
              onClick={handleCopy}
              className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              Copy Link
            </button>

            <div className="flex gap-3 justify-center mt-4">
              {/* Facebook Share */}
              <a 
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded-full hover:bg-blue-700"
              >
                <FaFacebookF size={16} />
              </a>

              {/* Tiktok Share */}
              <a 
                href={`https://www.tiktok.com/share?url=${encodeURIComponent(shareUrl)}&text=Check out this amazing content!`}
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-black text-white rounded-full hover:bg-blue-500"
              >
                <FaTiktok  size={16} />
              </a>

              {/* Instagram and YouTube Links */}
              <a 
                href="https://www.instagram.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-pink-500 text-white rounded-full hover:bg-pink-600"
              >
                <FaInstagram size={16} />
              </a>

              <a 
                href="https://www.youtube.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-red-600 text-white rounded-full hover:bg-red-700"
              >
                <FaYoutube size={16} />
              </a>
            </div>

            <button 
              onClick={() => setModalOpen(false)}
              className="mt-4 text-red-500 font-bold hover:underline"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
